import store from '@state/store'

export default [
    {
        path: '/dashboard/resettlement',
        name: 'DashboardResettlement',
        component: () => lazyLoadView(import('@views/dashboard/resettlements/report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/',
        name: 'home',
        component: () => lazyLoadView(import('@views/home')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },


    {
        path: '/login',
        name: 'login',
        component: () => lazyLoadView(import('@views/login')),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'home'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    
    {
        path: '/ses/land/house/report/package',
        name: 'sesLandHouseReportPackage',
        component: () => lazyLoadView(import('@views/ses/views/house_report_package/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/ses/land/house/report/package/A',
        name: 'sesLandHouseReportPackageA',
        component: () => lazyLoadView(import('@views/ses/views/house_report_package/listA')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/ses/land/house/report/package/B',
        name: 'sesLandHouseReportPackageB',
        component: () => lazyLoadView(import('@views/ses/views/house_report_package/listB')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/ses/land/house/report/package/AB',
        name: 'sesLandHouseReportPackageAB',
        component: () => lazyLoadView(import('@views/ses/views/house_report_package/listAB')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/trainee/iga/self-emplyment/list',
        name: 'igaSelfEmployment',
        component: () =>
            lazyLoadView(import('@views/report/iga-self-employment')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/iga/income-from-trade/list',
        name: 'igaIncomeFromTrade',
        component: () =>
            lazyLoadView(import('@views/report/iga-income-from-trade')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
    path: '/trainee/iga/job-holder/list',
        name: 'jobHolderList',
        component: () =>
            lazyLoadView(import('@views/report/iga-job-holders')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/iga/employment-status',
            name: 'employmentStatus',
            component: () =>
                lazyLoadView(import('@views/report/employment-status')),
            meta: {
                authRequired: true,
            },
            props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/iga/involved-with-others/list',
        name: 'involvedWithOthers',
        component: () =>
            lazyLoadView(import('@views/report/iga-involved-with-others')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/education/report',
        name: 'traineeEducationReport',
        component: () =>
            lazyLoadView(import('@views/report/education-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: () => lazyLoadView(import('@views/register')),
    //   meta: {
    //     beforeResolve(routeTo, routeFrom, next) {
    //       // If the user is already logged in
    //       if (store.getters['auth/loggedIn']) {
    //         // Redirect to the home page instead
    //         next({ name: 'home' })
    //       } else {
    //         // Continue to the login page
    //         next()
    //       }
    //     },
    //   },
    // },
    {
        path: '/confirm-account',
        name: 'confirm-account',
        component: () => lazyLoadView(import('@views/confirm')),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'home'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forget-password',
        name: 'forget-password',
        component: () => lazyLoadView(import('@views/forgetPassword')),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({name: 'home'})
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/update-password',
        name: 'updatePassword',
        component: () => lazyLoadView(import('@views/update-password')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                store.dispatch('auth/logOut')
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.meta.authRequired
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? {name: 'home'} : {...routeFrom})
            },
        },
    },
    {
        path: '/404',
        name: '404',
        component: require('@views/_404').default,
        // Allows props to be passed to the 404 page through route
        // params, such as `resource` to define what wasn't found.
        props: true,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
        path: '*',
        redirect: '404',
    },

    // Trainers
    {
        path: '/trainers/list',
        name: 'trainerList',
        component: () => lazyLoadView(import('@views/trainers/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Trade Chart
    {
        path: '/trade/:trade_id',
        name: 'tradeHome',
        component: () => lazyLoadView(import('@views/home')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Trainee
    {
        path: '/trainee/create',
        name: 'traineeCreate',
        component: () => lazyLoadView(import('@views/trainee/create_tms')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/view/update/list',
        name: 'traineeViewUpdateList',
        component: () => lazyLoadView(import('@views/trainee/update-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/list',
        name: 'traineeList',
        component: () => lazyLoadView(import('@views/trainee/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/waiting/list',
        name: 'traineeWaitingList',
        component: () => lazyLoadView(import('@views/trainee/waiting-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/batch/list',
        name: 'batchTraineeList',
        component: () => lazyLoadView(import('@views/trainee/batch-trainee-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/search/custom',
        name: 'traineeSearch',
        component: () => lazyLoadView(import('@views/trainee/trainee-custom-search')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/view/:trainee_id',
        name: 'traineeView',
        component: () => lazyLoadView(import('@views/trainee/view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/edit/:trainee_id',
        name: 'traineeEdit',
        component: () => lazyLoadView(import('@views/trainee/edit_tms')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/all/document/list',
        name: 'traineeAllDocumentList',
        component: () => lazyLoadView(import('@views/trainee/uploads/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/report/document/list',
        name: 'traineeReportDocumentList',
        component: () => lazyLoadView(import('@views/report/trainee-doc-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/document/list/:trainee_id',
        name: 'traineeDocumentList',
        component: () => lazyLoadView(import('@views/trainee/uploads/view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/document/create/:trainee_id',
        name: 'traineeDocumentCreate',
        component: () => lazyLoadView(import('@views/trainee/uploads/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/document/update/:document_id',
        name: 'traineeDocumentUpdate',
        component: () => lazyLoadView(import('@views/trainee/uploads/update')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/uploads/create/:trainee_id',
        name: 'traineeUploadsCreate',
        component: () => lazyLoadView(import('@views/trainee/uploads/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/view/doc/update',
        name: 'traineeViewDocUpdate',
        component: () => lazyLoadView(import('@views/trainee/uploads/update-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/view/doc/list',
        name: 'traineeViewDocList',
        component: () => lazyLoadView(import('@views/trainee/uploads/trainee-doc-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/document/file-tracking/list/:trainee_id',
        name: 'traineeDocumentTracking',
        component: () => lazyLoadView(import('@views/trainee/uploads/file_tracking/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/document/file-tracking/print-view/:trainee_id',
        name: 'traineeDocumentTrackingPrintView',
        component: () => lazyLoadView(import('@views/trainee/uploads/file_tracking/print-view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainees/nid-duplicate/list',
        name: 'traineeNidDuplicateList',
        component: () => lazyLoadView(import('@views/trainee/duplicated-nid-check')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainees/field-book/list',
        name: 'traineeFieldBookListTrainee',
        component: () => lazyLoadView(import('@views/trainee/fieldbook-trainee')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainees/field-book/mismatch/list',
        name: 'traineeFieldBookMismatchList',
        component: () => lazyLoadView(import('@views/trainee/fieldbook-mismatch')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Followup DOc
    {
        path: '/trainee/followup-doc/create/:trainee_id',
        name: 'followupDocCreate',
        component: () => lazyLoadView(import('@views/trainee/followup/followup-doc/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/followup-doc/edit/:followup_doc_id',
        name: 'followupDocEdit',
        component: () => lazyLoadView(import('@views/trainee/followup/followup-doc/edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Computer Followup
    {
        path: '/trainee/computer-basic/followup/list/:trainee_id',
        name: 'computerBasicFollowupList',
        component: () => lazyLoadView(import('@views/trainee/followup/computer-basic/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/computer-basic/followup/create/:trainee_id/:form_no',
        name: 'computerBasicFollowupCreate',
        component: () => lazyLoadView(import('@views/trainee/followup/computer-basic/followup-create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/computer-basic/followup/edit/:followup_id',
        name: 'computerBasicFollowupEdit',
        component: () => lazyLoadView(import('@views/trainee/followup/computer-basic/followup-edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/computer-basic/followup-second/create/:trainee_id/:form_no',
        name: 'computerBasicFollowupSecondCreate',
        component: () => lazyLoadView(import('@views/trainee/followup/computer-basic/followup-second-create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/computer-basic/followup-second/edit/:followup_id',
        name: 'computerBasicFollowupSecondEdit',
        component: () => lazyLoadView(import('@views/trainee/followup/computer-basic/followup-second-edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/computer-basic/followup_last/create/:trainee_id/:form_no',
        name: 'computerBasicFollowupLastCreate',
        component: () => lazyLoadView(import('@views/trainee/followup/computer-basic/followup-last-create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/computer-basic/followup_last/edit/:followup_id',
        name: 'computerBasicFollowupLastEdit',
        component: () => lazyLoadView(import('@views/trainee/followup/computer-basic/followup-last-edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },


    // Mansion Work Followup
    {
        path: '/trainee/mansion-work/followup/list/:trainee_id',
        name: 'mansionWorkFollowupList',
        component: () => lazyLoadView(import('@views/trainee/followup/mansion-work/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/mansion-work/followup/create/:trainee_id/:form_no',
        name: 'mansionWorkFollowupCreate',
        component: () => lazyLoadView(import('@views/trainee/followup/mansion-work/followup-create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/mansion-work/followup/edit/:followup_id',
        name: 'mansionWorkFollowupEdit',
        component: () => lazyLoadView(import('@views/trainee/followup/mansion-work/followup-edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/mansion-work/followup-second/create/:trainee_id/:form_no',
        name: 'mansionWorkFollowupSecondCreate',
        component: () => lazyLoadView(import('@views/trainee/followup/mansion-work/followup-second-create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/mansion-work/followup-second/edit/:followup_id',
        name: 'mansionWorkFollowupSecondEdit',
        component: () => lazyLoadView(import('@views/trainee/followup/mansion-work/followup-second-edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/mansion-work/followup_last/create/:trainee_id/:form_no',
        name: 'mansionWorkFollowupLastCreate',
        component: () => lazyLoadView(import('@views/trainee/followup/mansion-work/followup-last-create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/mansion-work/followup_last/edit/:followup_id',
        name: 'mansionWorkFollowupLastEdit',
        component: () => lazyLoadView(import('@views/trainee/followup/mansion-work/followup-last-edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Followup
    {
        path: '/trainee/followup/search/list',
        name: 'traineeFollowupSearchList',
        component: () => lazyLoadView(import('@views/trainee/followup/general/trainee-followup-search')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/followup/list/:trainee_id',
        name: 'followupList',
        component: () => lazyLoadView(import('@views/trainee/followup/general/followup-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/followup/create/:trainee_id/:form_no',
        name: 'followupCreate',
        component: () => lazyLoadView(import('@views/trainee/followup/general/followup-create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/followup/edit/:followup_id',
        name: 'followupEdit',
        component: () => lazyLoadView(import('@views/trainee/followup/general/followup-edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/followup/create-first/:trainee_id/:form_no',
        name: 'followupCreateFirst',
        component: () => lazyLoadView(import('@views/trainee/followup/general/followup-create-first')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/followup/edit-first/:followup_id',
        name: 'followupEditFirst',
        component: () => lazyLoadView(import('@views/trainee/followup/general/followup-edit-first')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/followup/list',
        name: 'traineeFollowupList',
        component: () => lazyLoadView(import('@views/trainee/followup/general/trainee-followup-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/followup/report',
        name: 'traineeFollowupReport',
        component: () => lazyLoadView(import('@views/report/trainee-followup-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/followup/report/list',
        name: 'traineeFollowupReportList',
        component: () => lazyLoadView(import('@views/report/trainee-followup-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/followup/comparison/:trainee_id',
        name: 'followupComparison',
        component: () => lazyLoadView(import('@views/trainee/followup/general/followup-comparison')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/followup/view/:followup_id',
        name: 'traineeFollowupView',
        component: () => lazyLoadView(import('@views/trainee/followup/general/followup-view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Bank
    {
        path: '/trainee/bank/list',
        name: 'traineeBankList',
        component: () => lazyLoadView(import('@views/trainee/bank/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/bank/update/list',
        name: 'traineeBankUpdateList',
        component: () => lazyLoadView(import('@views/trainee/bank/update-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/bank/import',
        name: 'traineeBankImport',
        component: () => lazyLoadView(import('@views/trainee/bank/bank-import')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Batch
    {
        path: '/batch/create',
        name: 'batchCreate',
        component: () => lazyLoadView(import('@views/batch/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/update/list',
        name: 'batchUpdateList',
        component: () => lazyLoadView(import('@views/batch/update-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/update/modify/list',
        name: 'batchUpdateModifyList',
        component: () => lazyLoadView(import('@views/batch/batch-list-modify')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/list/',
        name: 'batchList',
        component: () => lazyLoadView(import('@views/batch/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/edit/:batch_id',
        name: 'batchEdit',
        component: () => lazyLoadView(import('@views/batch/edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/view/:batch_id',
        name: 'batchView',
        component: () => lazyLoadView(import('@views/batch/view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/batch/trainee/add',
        name: 'batchTraineeAdd',
        component: () => lazyLoadView(import('@views/batch/trainee/add')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/trainee/list',
        name: 'traineeBatchList',
        component: () => lazyLoadView(import('@views/batch/trainee/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Batch document
    {
        path: '/batch/all/document/list',
        name: 'batchAllDocumentList',
        component: () => lazyLoadView(import('@views/batch/upload/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/document/list/:batch_id',
        name: 'batchDocumentList',
        component: () => lazyLoadView(import('@views/batch/upload/view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/document/create/:batch_id',
        name: 'batchDocumentCreate',
        component: () => lazyLoadView(import('@views/batch/upload/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/trainee/view',
        name: 'batchTraineeView',
        component: () => lazyLoadView(import('@views/batch/trainee/view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/document/update/:document_id',
        name: 'batchDocumentUpdate',
        component: () => lazyLoadView(import('@views/batch/upload/update')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/batch/trainee',
        name: 'batchTrainee',
        component: () =>
            lazyLoadView(import('@views/batch/trainee/trainee-autocomplete')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    {
        path: '/batch/completed/list',
        name: 'batchCompletedList',
        component: () =>
            lazyLoadView(import('@views/batch/schedule/completed-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/ongoing/list',
        name: 'batchOngoingList',
        component: () => lazyLoadView(import('@views/batch/schedule/ongoing-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/upcoming/list',
        name: 'batchUpcomingList',
        component: () =>
            lazyLoadView(import('@views/batch/schedule/upcoming-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/grade',
        name: 'traineeGrade',
        component: () => lazyLoadView(import('@views/batch/grade/view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/grade/view',
        name: 'traineeGradeView',
        component: () => lazyLoadView(import('@views/batch/grade/grade-view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/grade/list/:trainee_id',
        name: 'traineeGradeList',
        component: () => lazyLoadView(import('@views/batch/grade/grade-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/trade/batch/list/:trade_id',
        name: 'tradeBatchesView',
        component: () => lazyLoadView(import('@views/batch/trade-batch')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/trainees/list/:batch_id',
        name: 'batchTraineesList',
        component: () => lazyLoadView(import('@views/batch/batch-trainee-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Attendance
    {
        path: '/trainee/attendance/add',
        name: 'traineeAttendanceAdd',
        component: () => lazyLoadView(import('@views/attendance/add')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/attendance/delete',
        name: 'traineeAttendanceDelete',
        component: () => lazyLoadView(import('@views/attendance/delete')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/batch/attendance/list',
        name: 'traineeBatchAttendanceList',
        component: () => lazyLoadView(import('@views/attendance/batch-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/attendance/report/:trainee_id',
        name: 'traineeAttendanceReport',
        component: () => lazyLoadView(import('@views/attendance/trainee-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/batch/daily-attendance/report',
        name: 'traineeDailyAttendanceReport',
        component: () =>
            lazyLoadView(import('@views/attendance/daily-attendance-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/batch/attendance/report',
        name: 'traineeAttendanceFullReport',
        component: () =>
            lazyLoadView(import('@views/attendance/attendance-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/mouza/report',
        name: 'traineeMouzaReport',
        component: () =>
            lazyLoadView(import('@views/report/trainee-mouza-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/union/report',
        name: 'traineeUnionReport',
        component: () =>
            lazyLoadView(import('@views/report/trainee-union-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/union/trainee/age/report',
        name: 'unionTraineeAgeReport',
        component: () =>
            lazyLoadView(import('@views/report/trainee-union-age-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/age-group/report',
        name: 'traineeAgeGroupReport',
        component: () =>
            lazyLoadView(import('@views/report/age-group-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/mouza/trainee/age/report',
        name: 'mouzaTraineeAgeReport',
        component: () =>
            lazyLoadView(import('@views/report/trainee-mouza-age-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/mouza/trainee/followup/age/report',
        name: 'mouzaTraineeFollowupAgeReport',
        component: () =>
            lazyLoadView(import('@views/report/trainee-mouza-followup-age-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trade/trainee/age/report',
        name: 'tradeTraineeAgeReport',
        component: () =>
            lazyLoadView(import('@views/report/trainee-trade-age-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/age/report',
        name: 'traineeAgeReport',
        component: () =>
            lazyLoadView(import('@views/report/trainee-age-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/trade/report',
        name: 'traineeTradeReport',
        component: () =>
            lazyLoadView(import('@views/report/trainee-trade-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/all/trade/report',
        name: 'traineeAllTradeReport',
        component: () =>
            lazyLoadView(import('@views/report/trainee-all-trade-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/all/batch/report',
        name: 'traineeAllBatchReport',
        component: () =>
            lazyLoadView(import('@views/report/trainee-all-batch-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/activity/report',
        name: 'activityReport',
        component: () =>
            lazyLoadView(import('@views/report/activity-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    //Dashboard List
    {
        path: '/dashboard/trainee/ongoing/list',
        name: 'dashboardTraineeOngoingList',
        component: () => lazyLoadView(import('@views/dashboard/trainee/ongoing-trainee')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/dashboard/trainee/completed/list',
        name: 'dashboardTraineeCompletedList',
        component: () => lazyLoadView(import('@views/dashboard/trainee/completed-trainee')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/dashboard/ongoing/batch/list',
        name: 'dashboardOngoingBatchList',
        component: () => lazyLoadView(import('@views/dashboard/trainee/total-ongoing-batch')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/dashboard/completed/batch/list',
        name: 'dashboardCompletedBatchList',
        component: () => lazyLoadView(import('@views/dashboard/trainee/total-completed-batch')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/dashboard/trainee/male/list',
        name: 'dashboardTraineeMaleList',
        component: () => lazyLoadView(import('@views/dashboard/trainee/total-male-trainee')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },



    {
        path: '/dashboard/trainees/gender/:c_gender_id',
        name: 'TraineesGender',
        component: () => lazyLoadView(import('@views/dashboard/trainee/trainees-by-gender')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },







    {
        path: '/dashboard/trainee/female/list',
        name: 'dashboardTraineeFemaleList',
        component: () => lazyLoadView(import('@views/dashboard/trainee/total-female-trainee')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Permission
    {
        path: '/user/list',
        name: 'userList',
        component: () => lazyLoadView(import('@views/user_management/user/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/role/list',
        name: 'userRoleList',
        component: () => lazyLoadView(import('@views/user_management/role/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/role/assign/:user_id',
        name: 'assignRole',
        component: () => lazyLoadView(import('@views/user_management/role/assignRole')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/role/permission/create/:role_id',
        name: 'assignPermission',
        component: () =>
            lazyLoadView(import('@views/user_management/role/assignPermission')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/logged/list',
        name: 'userLogged',
        component: () =>
            lazyLoadView(import('@views/user_management/report/user-logged')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/role/logged/list',
        name: 'userRoleLogged',
        component: () =>
            lazyLoadView(import('@views/user_management/report/user-role-logged')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/role/logged/list',
        name: 'roleLogged',
        component: () =>
            lazyLoadView(import('@views/user_management/report/role-logged')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/activity-log',
        name: 'activity-log',
        component: () =>
            lazyLoadView(import('@views/user_management/report/activity-log')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/active-users',
        name: 'active-users',
        component: () =>
            lazyLoadView(import('@views/user_management/report/active-users')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // report
    {
        path: '/trainee/batch/field-book/list',
        name: 'traineeBatchFieldBookList',
        component: () => lazyLoadView(import('@views/report/batch-trainee-field-book-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/not/field-book/list',
        name: 'traineeNotFieldBookList',
        component: () => lazyLoadView(import('@views/report/trainee-not-field-book-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/report',
        name: 'batchReport',
        component: () => lazyLoadView(import('@views/report/batch-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/batch/report',
        name: 'traineeBatchReport',
        component: () => lazyLoadView(import('@views/report/trainee-batch-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/report',
        name: 'traineeReport',
        component: () => lazyLoadView(import('@views/report/trainee-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/bank/report',
        name: 'traineeBankReport',
        component: () => lazyLoadView(import('@views/report/trainee-bank-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/report',
        name: 'sesReport',
        component: () => lazyLoadView(import('@views/report/ses-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/training/report',
        name: 'sesTrainingReport',
        component: () => lazyLoadView(import('@views/report/ses-training-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/household/report',
        name: 'sesHouseholdReport',
        component: () => lazyLoadView(import('@views/report/ses-household-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/land/report',
        name: 'sesLandReport',
        component: () => lazyLoadView(import('@views/report/ses-land-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/structure/report',
        name: 'sesStructureReport',
        component: () => lazyLoadView(import('@views/report/ses-structure-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/business/report',
        name: 'sesBusinessReport',
        component: () => lazyLoadView(import('@views/report/ses-business-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/centre/resettlement',
        name: 'resettlementCentre',
        component: () => lazyLoadView(import('@views/report/resettlement-centre')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/centre/resettlement/houses/:package_id',
        name: 'resettlementCentreHouses',
        component: () => lazyLoadView(import('@views/report/resettlement-centre-houses')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/centre/resettlement/houses/:package_id/:type_id',
        name: 'resettlementCentreTypeHouses',
        component: () => lazyLoadView(import('@views/report/resettlement-centre-type-houses')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Ses
    {
        path: '/ses/create',
        name: 'sesCreate',
        component: () => lazyLoadView(import('@views/ses/create/ses')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/views/update/list',
        name: 'sesViewUpdateList',
        component: () => lazyLoadView(import('@views/ses/views/update-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/views/list',
        name: 'sesList',
        component: () => lazyLoadView(import('@views/ses/views/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/edit/:ses_id',
        name: 'sesEdit',
        component: () => lazyLoadView(import('@views/ses/create/ses-edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/views/:ses_id',
        name: 'sesView',
        component: () => lazyLoadView(import('@views/ses/views/ses.vue')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/land/create/:ses_id',
        name: 'landCreate',
        component: () => lazyLoadView(import('@views/ses/create/land')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/structure/create/:ses_id',
        name: 'structureCreate',
        component: () => lazyLoadView(import('@views/ses/create/structure')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/tree/create/:ses_id',
        name: 'treeCreate',
        component: () => lazyLoadView(import('@views/ses/create/tree')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/household/create/:ses_id',
        name: 'houseHoldCreate',
        component: () => lazyLoadView(import('@views/ses/create/house-hold')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/business/create/:ses_id',
        name: 'businessCreate',
        component: () => lazyLoadView(import('@views/ses/create/business')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/house/list',
        name: 'sesHouseList',
        component: () => lazyLoadView(import('@views/ses/views/house-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/create/step-two/:ses_id',
        name: 'sesTwoCreate',
        component: () => lazyLoadView(import('@views/ses/create/ses-step-two')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/uploads/list',
        name: 'sesUploadsList',
        component: () => lazyLoadView(import('@views/ses/uploads/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/uploads/file-track/:ses_id',
        name: 'sesDocumentTracking',
        component: () => lazyLoadView(import('@views/ses/uploads/file_tracking/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/doc/update/list',
        name: 'sesDocUpdateList',
        component: () => lazyLoadView(import('@views/ses/uploads/update-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/document/create/:ses_id',
        name: 'sesDocumentCreate',
        component: () => lazyLoadView(import('@views/ses/uploads/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/document/update/:ses_id',
        name: 'sesDocumentUpdate',
        component: () => lazyLoadView(import('@views/ses/uploads/update')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/document/list/:ses_id',
        name: 'sesDocumentList',
        component: () => lazyLoadView(import('@views/ses/uploads/view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/view/doc/list',
        name: 'sesViewDocList',
        component: () => lazyLoadView(import('@views/ses/uploads/view-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Ses Land
    {
        path: '/ses/land/list',
        name: 'sesLandList',
        component: () => lazyLoadView(import('@views/ses/views/land/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Payment
    {
        path: '/trainee/voucher/create',
        name: 'traineeVoucherCreate',
        component: () => lazyLoadView(import('@views/trainee/voucher/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/voucher/update/list',
        name: 'traineeVoucherUpdateList',
        component: () =>
            lazyLoadView(import('@views/trainee/voucher/update-voucher-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/voucher/edit/:voucher_id',
        name: 'traineeVoucherEdit',
        component: () => lazyLoadView(import('@views/trainee/voucher/edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/voucher/list',
        name: 'traineeVoucherList',
        component: () =>
            lazyLoadView(import('@views/trainee/voucher/voucher-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Voucher report
    {
        path: '/trainee/voucher/date/list',
        name: 'traineeVoucherDateList',
        component: () =>
            lazyLoadView(import('@views/report/trainee-voucher-date-range-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/voucher/report',
        name: 'traineeVoucherReport',
        component: () =>
            lazyLoadView(import('@views/report/voucher-report')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/calculation-sheet',
        name: 'calculationSheet',
        component: () =>
            lazyLoadView(import('@views/report/calculation-sheet')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Trade Course
    {
        path: '/trainee/trade/course/list',
        name: 'traineeTradeCourseList',
        component: () => lazyLoadView(import('@views/trainee/trade-course/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/trade/course/create',
        name: 'traineeTradeCourseCreate',
        component: () => lazyLoadView(import('@views/trainee/trade-course/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/trade/course/update/:trade_course_id',
        name: 'traineeTradeCourseUpdate',
        component: () => lazyLoadView(import('@views/trainee/trade-course/edit')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/trade/course/updateList',
        name: 'traineeTradeCourseUpdateList',
        component: () => lazyLoadView(import('@views/trainee/trade-course/update-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // ID card
    {
        path: '/trainee/id-card',
        name: 'traineeIdCard',
        component: () => lazyLoadView(import('@views/id_card/trainee')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainer/id-card',
        name: 'trainerIdCard',
        component: () => lazyLoadView(import('@views/id_card/trainers')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Exam
    {
        path: '/trainee/exam/list',
        name: 'traineeExamList',
        component: () => lazyLoadView(import('@views/trainee/exam/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/exam/list/view',
        name: 'traineeExamListView',
        component: () => lazyLoadView(import('@views/trainee/exam/view-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/batch/grade/list',
        name: 'batchGradeList',
        component: () => lazyLoadView(import('@views/batch/grade/batch-grade-view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/exam/create',
        name: 'traineeExamCreate',
        component: () => lazyLoadView(import('@views/trainee/exam/create')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // profile
    {
        path: '/user/profile',
        name: 'userProfile',
        component: () => lazyLoadView(import('@views/profile/index')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/profile/update',
        name: 'userProfileUpdate',
        component: () => lazyLoadView(import('@views/profile/profile-update')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/user/password/update',
        name: 'userPasswordUpdate',
        component: () => lazyLoadView(import('@views/profile/password-update')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => lazyLoadView(import('@views/forgetPassword')),
        meta: {
            auth: false,
        },
    },
    {
        path: '/reset-password-with-code/:email',
        name: 'reset-password-form-with-code',
        component: () => lazyLoadView(import('@views/reset-password-form')),
        meta: {
            auth: false,
        },
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password-form',
        component: () => lazyLoadView(import('@views/profile/password-update')),
        meta: {
            auth: false,
        },
    },

    // PDF
    {
        path: '/trainee/list/pdf',
        name: 'traineePdfList',
        component: () => lazyLoadView(import('@views/trainee/pdf/trainee-pdf-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/pdf',
        name: 'traineePdf',
        component: () => lazyLoadView(import('@views/trainee/pdf/trainee-pdf')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Profile
    {
        path: '/trainee/profile/search',
        name: 'traineeProfileSearch',
        component: () => lazyLoadView(import('@views/trainee/profile/search')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/profile/info/:trainee_id',
        name: 'traineeProfileInfo',
        component: () => lazyLoadView(import('@views/trainee/profile/profile')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/profile/document/:trainee_id',
        name: 'traineeProfileDocument',
        component: () => lazyLoadView(import('@views/trainee/profile/document')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/profile/batch/:trainee_id',
        name: 'traineeProfileBatch',
        component: () => lazyLoadView(import('@views/trainee/profile/batch')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/profile/attendance/:trainee_id',
        name: 'traineeProfileAttendance',
        component: () => lazyLoadView(import('@views/trainee/profile/attendance')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/profile/bank/:trainee_id',
        name: 'traineeProfileBank',
        component: () => lazyLoadView(import('@views/trainee/profile/bank')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/profile/voucher/:trainee_id',
        name: 'traineeProfileVoucher',
        component: () => lazyLoadView(import('@views/trainee/profile/voucher')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/profile/followup/:trainee_id',
        name: 'traineeProfileFollowup',
        component: () => lazyLoadView(import('@views/trainee/profile/followup')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    }, {
        path: '/trainee/profile/grade/:trainee_id',
        name: 'traineeProfileGrade',
        component: () => lazyLoadView(import('@views/trainee/profile/grade')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },

    // Land Report
    {
        path: '/ses/land/search/list',
        name: 'sesLandSearchList',
        component: () => lazyLoadView(import('@views/ses/views/land_report/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/land/report/village/:village_id',
        name: 'landReportVillage',
        component: () => lazyLoadView(import('@views/ses/views/land_report/village')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/ses/land/report/mouza/:mouza_id',
        name: 'landReportMouza',
        component: () => lazyLoadView(import('@views/ses/views/land_report/mouza')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    // Field book
    {
        path: '/trainee/field-book/list',
        name: 'traineeFieldBookList',
        component: () => lazyLoadView(import('@views/trainee/field_book/update-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/field-book/group/list',
        name: 'traineeFieldBookGroupList',
        component: () => lazyLoadView(import('@views/trainee/field_book/field-book-group')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/field-book/group/view',
        name: 'traineeFieldBookGroupView',
        component: () => lazyLoadView(import('@views/trainee/field_book/field-book-group-view')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/field-book/group/update/list',
        name: 'traineeFieldBookGroupUpdateList',
        component: () => lazyLoadView(import('@views/trainee/field_book/update-field-book-group')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/field-book/view/list',
        name: 'traineeFieldBookViewList',
        component: () => lazyLoadView(import('@views/trainee/field_book/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/field-book/report',
        name: 'traineeFieldBookReport',
        component: () => lazyLoadView(import('@views/report/field-book-list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    //crud module manager
    {
        path: '/affected-type/list',
        name: 'affected-type-list',
        component: () => lazyLoadView(import('@views/crud-module/affected-type/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/users/list',
        name: 'users-list',
        component: () => lazyLoadView(import('@views/crud-module/users/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/mouzas/list',
        name: 'mouzas-list',
        component: () => lazyLoadView(import('@views/crud-module/mouzas/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/villages/list',
        name: 'villages-list',
        component: () => lazyLoadView(import('@views/crud-module/villages/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/banks/list',
        name: 'banks-list',
        component: () => lazyLoadView(import('@views/crud-module/banks/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/unions/list',
        name: 'union-list',
        component: () => lazyLoadView(import('@views/crud-module/unions/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/upazilas/list',
        name: 'upazilas-list',
        component: () => lazyLoadView(import('@views/crud-module/upazilas/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/venues/list',
        name: 'venues-list',
        component: () => lazyLoadView(import('@views/crud-module/venues/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainers-module/list',
        name: 'trainers-module-list',
        component: () => lazyLoadView(import('@views/crud-module/trainers/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trades/list',
        name: 'trades-list',
        component: () => lazyLoadView(import('@views/crud-module/trades/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/training-duration/list',
        name: 'training-duration',
        component: () => lazyLoadView(import('@views/crud-module/training-duration/list')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },


    // Testing
    {
        path: '/testingReport',
        name: 'testingReport',
        component: () => lazyLoadView(import('@views/trainee/testingReport')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
    {
        path: '/trainee/after-training-iga-info',
        name: 'after-training-iga-info',
        component: () => lazyLoadView(import('@views/report/iga-after-training-info')),
        meta: {
            authRequired: true,
        },
        props: route => ({user: store.state.auth.currentUser || {}}),
    },
]

function lazyLoadView(AsyncView) {
    const AsyncHandler = () => ({
        component: AsyncView,
        loading: require('@views/_loading').default,
        delay: 200,
        error: require('@views/_timeout').default,
        timeout: 10000,
    })

    return Promise.resolve({
        functional: true,
        render(h, {data, children}) {
            return h(AsyncHandler, data, children)
        },
    })
}
